import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updatePurchaseOrderInvoiceApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updatePurchaseOrderInvoice = createAsyncThunk('updatePurchaseOrderInvoice', async (payload) => {
  return await updatePurchaseOrderInvoiceApi(payload);
});

const updatePurchaseOrderInvoiceSlice = createSlice({
  name: 'updatePurchaseOrderInvoice', // Unique Name
  initialState,
  reducers: {
    updatePurchaseOrderInvoiceReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePurchaseOrderInvoice.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updatePurchaseOrderInvoice.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updatePurchaseOrderInvoice.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updatePurchaseOrderInvoiceReset } = updatePurchaseOrderInvoiceSlice.actions;

export default updatePurchaseOrderInvoiceSlice.reducer;
